module.exports = __webpack_public_path__ + "static/media/GALAD Тандем LED.acfc1d5a.jpg";